// iOS scroll fix

const getScrollParent = function (elm = this.$el) {
  let result

  if (elm.tagName === 'BODY') {
    // result = window
    result = elm
  } else if (
    ['scroll', 'auto'].indexOf(window.getComputedStyle(elm).overflowY) > -1
  ) {
    result = elm
  }

  return result || getScrollParent(elm.parentNode)
}

// const overscroll = function (el) {
//   const onePixel = true
//
//   if (onePixel) {
//     el.addEventListener('touchstart', function () {
//       let top           = el.scrollTop
//       let totalScroll   = el.scrollHeight
//       let currentScroll = top + el.offsetHeight
//
//       // If we're at the top or the bottom of the containers
//       // scroll, push up or down one pixel.
//       //
//       // this prevents the scroll from "passing through" to
//       // the body.
//       if (top === 0) {
//         el.scrollTop = 1
//       } else if (currentScroll === totalScroll) {
//         el.scrollTop = top - 1
//       }
//     })
//   }
//
//   el.addEventListener('touchmove', function (e) {
//     // if the content is actually scrollable, i.e. the content is long enough
//     // that scrolling can occur
//     if (el.offsetHeight < el.scrollHeight) e._isScroller = true
//   })
// }

if (document) {
  document.body.addEventListener('touchstart', function (e) {
    let el = getScrollParent(e.target)
    let top           = el.scrollTop
    let totalScroll   = el.scrollHeight
    let currentScroll = top + el.offsetHeight

    // If we're at the top or the bottom of the containers
    // scroll, push up or down one pixel.
    //
    // this prevents the scroll from "passing through" to
    // the body.
    if (top === 0) {
      el.scrollTop = 1
    } else if (currentScroll === totalScroll) {
      el.scrollTop = top - 1
    }
  })

  document.body.addEventListener('touchmove', function (e) {
    // let t = e.currentTarget || e.target
    let el = getScrollParent(e.target)

    if (el.offsetHeight < el.scrollHeight) e._isScroller = true
    // In this case, the default behavior is scrolling the body, which
    // would result in an overflow.  Since we don't want that, we preventDefault.
    if (!e._isScroller) {
      e.preventDefault()
    }
  }, {passive: false})
}
